import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import ReactDOM from "react-dom";
import Package from "components/Package";
import { useTranslation } from "react-i18next";

const ShowPackageModal: FC<Props> = ({ previewPackage, toggle }) => {
  const { t } = useTranslation();
  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{t("packages.package")}</div>
          <CloseIcon onClick={toggle} />
        </div>
        <div className={styles.content}>
          <Package
            kind={previewPackage.Kind.toString()}
            packageId={previewPackage.Id}
            onDownload={() => {}}
            onPreview={() => {}}
            showVersion={false}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ShowPackageModal;
